import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

const ArticleTilePlaceholder = () => {

  return (
    <>
      <Placeholder type="text" height="66px" />
      {new Array(5).fill('').map((value, key) => (
        <Placeholder key={`text-${key}`} type="text" />
      ))}
      <Placeholder type="text" height="80px" />
      <Placeholder type="text" height="40px" />
      {/* Placeholder below is for services integration link */}
      {/* <Placeholder type="text" height="20px" /> */}
    </>
  );
};

export { ArticleTilePlaceholder };
